import { render, staticRenderFns } from "./EditarSenhaAdministrador.vue?vue&type=template&id=ce648752"
import script from "./EditarSenhaAdministrador.vue?vue&type=script&lang=js"
export * from "./EditarSenhaAdministrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports